import Header from "../../../../Components/Header/Header"
import Sidebar from "../../../../Components/Sidebar/Sidebar"
import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import DeletePopup from "../GardenPopup/DeletePopup"
import SectorMasterPopup from "./SectorMasterPopup"
import { WardNameDataDDL } from "../../../../Components/CommonDDL/WardNameDataDDL"
import { useAuthState } from "../../../../Helper/Context"
import { useDispatch, useSelector } from "react-redux"
import { SectorDeleteAPI, SectorTableDataAPI } from "../../../../Redux/SidebarMasterSlice/SectorMasterSlice"
import { Pegination } from "../../../../Components/Pegination/Pegination"
import { Loading } from "../../../../Helper/Loading"
import { useSearchParams } from "react-router-dom"

export const SectorMaster = () => {

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")
    let Lang = searchParams.get("Lang")

    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [From, setFrom] = useState(1)
    const [To, setTo] = useState(10)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [IsPost, setIsPost] = useState(false)
    const [IsClear, setIsClear] = useState(false)

    const [MasterPopupShow, setMasterPopupShow] = useState()
    const [DeletePopupShow, setDeletePopupShow] = useState()
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    // const [SectorName, setSectorName] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select...",
    // })

    const [Language, setLanguage] = useState({
        DDL: [],
        ID: 0,
        Label: Lang,
    })
    const handleIsPost = () => {
        setIsPost(!IsPost)
        // if (tableData && tableData.table && tableData.table.length > 0) {
        //     setCurrentPage(0)
        //     setFrom(1)
        //     setTo(10)
        // }
    }

    const handleClear = () => {
        setCurrentPage(0)
        setIsClear(!IsClear)
        // setSectorName({
        //     ...SectorName,
        //     ID: 0,
        //     Label: 'Select...'
        // })
        setWardName({
            ...WardName,
            ID: 0,
            Label: 'Select...'
        })
    }

    const handleAddOnClick = () => {
        setapiFlag('Insert')
        setMasterPopupShow(true)
    }
    const handleEditOnClick = (item) => {
        setMasterPopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }

    const handleOnCloseClick = () => {
        setMasterPopupShow(false)
    }

    useEffect(() => {
        setCurrentPage(0)
        setFrom(1)
        setTo(10)
    }, [WardName.ID])

    useEffect(() => {
        const data = {
            M_WardID: WardName.ID,
            // M_GD_SectorID: SectorName.ID,
            SectorName: '',
            M_UsersID: UserID,
            token: token,
            From: From,
            To: To,
        }
        dispatch(SectorTableDataAPI({ data }))
    }, [IsPost, To, WardName.ID,IsClear])

    const { tableData, isLoading } = useSelector(state => state.SectorTableData)

    const handleDeleteApi = (item) => {
        const data = {
            M_GD_SectorID: item.m_SectorID,
            M_UserID: UserID,
            token: token,
            handleIsPost: handleIsPost
        }
        dispatch(SectorDeleteAPI({ data }))
    }

    const { isDeleteLoading } = useSelector(state => state.SectorDeleteData)


    // const [SelectWard, setSelectWard] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select Ward",
    // })

    return (
        <>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <div>
                <Header
                    // DashboardHeading="Garden Maintainance"
                    DashboardName={DashboardName}
                />
                <div className="wrapper p-3">
                    <Sidebar
                        Language={Language}
                        ProjectTypeId={ProjectTypeId} />
                    <div className="content">
                        <div className="data_mob">
                            <div className="row  m-1 py-1 pb-4 master_border">
                                <div>
                                    <h5 className="ps-1 py-2 ">Sector Garden Master</h5>
                                    <div className="col-12 col-lg-7 float-end">
                                        <i className="fa-solid fa-plus btn btn-secondary float-end mb-2"
                                            style={{ color: "white", marginTop: '-2.5em' }}
                                            onClick={handleAddOnClick}
                                        >
                                            <text className="ml-2 poppins">Add</text>
                                        </i>
                                    </div>
                                </div>
                                <div className="row m-0 ">
                                    <div className="col-12 py-1 rounded rounded-2 shadow"
                                        style={{ border: "1px solid #00000024", background: " #27466317" }}>
                                        <div className="col-12  ">

                                            <div className="row py-1 rounded2">

                                                <div className="col-12 col-md-5 col-lg-3">
                                                    <WardNameDataDDL
                                                        WardName={WardName}
                                                        setWardName={setWardName}
                                                    // Flag='ward'
                                                    />
                                                </div>

                                                {/* <div className="col-12 col-md-5 col-lg-3">
                                                    <SectorDataDDL
                                                        SectorName={SectorName}
                                                        setSectorName={setSectorName}
                                                        WardName={WardName}

                                                    />
                                                </div> */}
                                                <div className="col-12 col-md-1 col-lg-2 mt-lg-4 mt-md-4" >
                                                    <button type="button" className="btn-clear btn btn-primary"
                                                        onClick={handleClear}
                                                    >Clear</button>
                                                </div>
                                            </div>
                                            <div className="row mob_table table-responsive pt-1">

                                                <table id="totalordergenerated"
                                                    cellPadding="0"
                                                    cellSpacing="0"
                                                    border="0"
                                                    className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th className="sr_no_col">Sr No.</th>
                                                            <th>Prabhag No</th>
                                                            {/* <th>Sector Name</th> */}
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) => (
                                                                <tr style={{ width: '100%' }}>
                                                                    <td style={{ textAlign: "center" }}>{item.rowNum}</td>
                                                                    <td>{item.wardName ? item.wardName : '-'}</td>
                                                                    {/* <td>{item.sectorName ? item.sectorName : '-'}</td> */}
                                                                    <td style={{ textAlign: "center", width: '7%' }}>
                                                                        <span>
                                                                            <i className="fa-solid fa-pen-to-square"
                                                                                onClick={() => handleEditOnClick(item)}
                                                                            ></i>
                                                                        </span>
                                                                        <DeletePopup
                                                                            open={DeletePopupShow}
                                                                            item={item}
                                                                            handleDeleteApi={handleDeleteApi}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            ))
                                                                :
                                                                <>No data found</>
                                                        }

                                                    </tbody>
                                                </table>

                                            </div>
                                            {tableData && tableData.table && tableData.table.length > 0 &&
                                                <Pegination
                                                    PerPageCount={PerPageCount}
                                                    TotalCount={tableData.table[0].totalCount}
                                                    setFrom={setFrom}
                                                    setTo={setTo}
                                                    setrowNo={setrowNo}
                                                    CurrentPage={CurrentPage}
                                                    setCurrentPage={setCurrentPage}
                                                    IsClear={IsClear}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                {
                    <SectorMasterPopup
                        open={MasterPopupShow}
                        handleIsPost={handleIsPost}
                        handleOnCloseClick={handleOnCloseClick}
                        rowData={rowData}
                        Flag={apiFlag}
                    />
                }
            </div>
        </>
    )
}